import React from "react";

const dummyShipments = [
  { id: "SHP-001", product: "Pump", status: "In Transit", eta: "2025-09-25" },
  { id: "SHP-002", product: "Gear Assembly", status: "Pending Pickup", eta: "2025-09-28" },
  { id: "SHP-003", product: "Hydraulic Cylinder", status: "Delivered", eta: "2025-09-20" },
];

export default function SyntraMfgLogisticsPage({ onClose }) {
  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-700">Shipments (Dummy Data)</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-gray-50 border rounded-lg">
          <thead>
            <tr className="text-left border-b">
              <th className="p-2">ID</th>
              <th className="p-2">Product</th>
              <th className="p-2">Status</th>
              <th className="p-2">ETA</th>
            </tr>
          </thead>
          <tbody>
            {dummyShipments.map((s, idx) => (
              <tr key={idx} className="border-b">
                <td className="p-2">{s.id}</td>
                <td className="p-2">{s.product}</td>
                <td className="p-2">{s.status}</td>
                <td className="p-2">{s.eta}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
